/**
 * Ranura de aside propia de página: el shell reserva la columna (la misma
 * retícula que usa la sidepane compartida de la cola en otras rutas — ver
 * layout.css `.aside`); la página que la ocupa (hoy solo /cola, con
 * «Resueltas hoy») decide qué va dentro, sin levantar su estado al shell.
 */
import { createContext, useContext, useEffect, type ReactNode } from "react";

const AsideSlotCtx = createContext<((content: ReactNode) => void) | null>(null);
export const AsideSlotProvider = AsideSlotCtx.Provider;

/** La página llama esto con lo que quiere ver en el aside; se limpia al desmontar o cambiar de ruta. */
export function useAsideSlot(content: ReactNode) {
  const set = useContext(AsideSlotCtx);
  useEffect(() => {
    set?.(content);
    return () => set?.(null);
  }, [content, set]);
}
